// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Mulish:wght@200;300;400;500;600;700;800;900&family=Poppins:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500&family=Roboto:wght@100;300;400;500;700;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*------Color Pallet------*/
/*------Font------*/
/*------Mixin------*/
body {
  padding: 0;
  margin: 0;
  font-family: "Roboto", sans-serif, Arial, Helvetica, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  scroll-behavior: smooth;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

h1 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 56px;
  font-weight: 600 !important;
  line-height: 67.2px;
  font-style: "normal";
}

h2 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 48px;
  font-weight: 600 !important;
  line-height: 57.6px;
  font-style: "normal";
}

h3 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 22px;
  font-weight: 600 !important;
  line-height: 26.4px;
  font-style: "normal";
}

.content_1 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 20px;
  font-weight: 400 !important;
  line-height: 30px;
  font-style: "normal";
}

.content_sm1 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 16px;
  font-weight: 400 !important;
  line-height: 24px;
  font-style: "normal";
}

.content_sm3 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 12px;
  font-weight: 400 !important;
  line-height: 18px;
  font-style: "normal";
}

.content_sm4 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 18px;
  font-weight: 600 !important;
  line-height: 27px;
  font-style: "normal";
}

.content_sm5 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 14px;
  font-weight: 400 !important;
  line-height: 18px;
  font-style: "normal";
}

p {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 20px;
  font-weight: 400 !important;
  line-height: 30px;
  font-style: "normal";
}

a,
h5,
h6 {
  font-family: "Roboto", sans-serif, Arial, Helvetica;
}`, "",{"version":3,"sources":["webpack://./src/styles/index.scss"],"names":[],"mappings":"AAEA,2BAAA;AAeA,mBAAA;AAQA,oBAAA;AA8BA;EACE,UAAA;EACA,SAAA;EACA,sMAAA;EAGA,mCAAA;EACA,kCAAA;EACA,uBAAA;AApDF;;AAuDA;EACE,+EAAA;AApDF;;AAwDA;EAvBE,2EAAA;EACA,eAuB4B;EAtB5B,2BAAA;EACA,mBAqBuC;EApBvC,oBAoB+C;AAjDjD;;AAmDA;EA1BE,2EAAA;EACA,eA0B4B;EAzB5B,2BAAA;EACA,mBAwBuC;EAvBvC,oBAuB+C;AA5CjD;;AA8CA;EA7BE,2EAAA;EACA,eA6B4B;EA5B5B,2BAAA;EACA,mBA2BuC;EA1BvC,oBA0B+C;AAvCjD;;AA0CA;EAjCE,8DAAA;EACA,eAiC0B;EAhC1B,2BAAA;EACA,iBA+BqC;EA9BrC,oBA8B2C;AAnC7C;;AAqCA;EApCE,8DAAA;EACA,eAoC0B;EAnC1B,2BAAA;EACA,iBAkCqC;EAjCrC,oBAiC2C;AA9B7C;;AAgCA;EAvCE,8DAAA;EACA,eAuC0B;EAtC1B,2BAAA;EACA,iBAqCqC;EApCrC,oBAoC2C;AAzB7C;;AA2BA;EA1CE,8DAAA;EACA,eA0C0B;EAzC1B,2BAAA;EACA,iBAwCqC;EAvCrC,oBAuC2C;AApB7C;;AAsBA;EA7CE,8DAAA;EACA,eA6C0B;EA5C1B,2BAAA;EACA,iBA2CqC;EA1CrC,oBA0C2C;AAf7C;;AAiBA;EAhDE,8DAAA;EACA,eAgD0B;EA/C1B,2BAAA;EACA,iBA8CqC;EA7CrC,oBA6C2C;AAV7C;;AAYA;;;EAGE,mDA/EU;AAsEZ","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Mulish:wght@200;300;400;500;600;700;800;900&family=Poppins:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500&family=Roboto:wght@100;300;400;500;700;900&display=swap\");\n\n/*------Color Pallet------*/\n$theme: #6366f1;\n$theme-light: #f2f3fa;\n$primary-light: #ffffff;\n$secondary-light: #f7f7f7;\n$primary-dark: #2c2f33;\n$secondary-dark: #23272a;\n$fnt-muted: #6c757d;\n$button-bg: #e0e7ff;\n$button-text: #3730a3;\n$button-hover: #3730a3;\n$button-danger-bg: #fee2e2;\n$button-danger-text: #dc2626;\n$button-danger-hover: #ef4444;\n\n/*------Font------*/\n$size-sm: 0.75rem;\n$size-md: 0.875rem;\n$size-lg: 1.25rem;\n\n$font-header: \"Poppins\", \"Roboto\", \"sans-serif\", Arial, Helvetica;\n$font-body: \"Roboto\", sans-serif, Arial, Helvetica;\n\n/*------Mixin------*/\n\n//Button\n@mixin btn-style($bgColor, $color, $border, $fw) {\n  background-color: $bgColor !important;\n  color: $color !important;\n  border: $border !important;\n  font-weight: $fw !important;\n}\n\n@mixin title-text($color, $fs, $ltrspace, $fw) {\n  color: $color !important;\n  font-size: $fs;\n  letter-spacing: $ltrspace !important;\n  font-weight: $fw !important;\n}\n\n@mixin header-footer-font($fntSize, $fntFam, $fntW) {\n  font-size: $fntSize;\n  font-family: $fntFam;\n  font-weight: $fntW;\n}\n@mixin font($fntFam, $fntSize, $fntW, $lineH, $fontStyle) {\n  font-family: $fntFam !important;\n  font-size: $fntSize;\n  font-weight: $fntW !important;\n  line-height: $lineH;\n  font-style: $fontStyle;\n}\n\nbody {\n  padding: 0;\n  margin: 0;\n  font-family: $font-body, -apple-system, BlinkMacSystemFont, \"Segoe UI\",\n    \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\",\n    \"Helvetica Neue\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  scroll-behavior: smooth;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\nh1 {\n  @include font($font-header, 56px, 600, 67.2px, \"normal\");\n}\nh2 {\n  @include font($font-header, 48px, 600, 57.6px, \"normal\");\n}\nh3 {\n  @include font($font-header, 22px, 600, 26.4px, \"normal\");\n}\n\n.content_1 {\n  @include font($font-body, 20px, 400, 30px, \"normal\");\n}\n.content_sm1 {\n  @include font($font-body, 16px, 400, 24px, \"normal\");\n}\n.content_sm3 {\n  @include font($font-body, 12px, 400, 18px, \"normal\");\n}\n.content_sm4 {\n  @include font($font-body, 18px, 600, 27px, \"normal\");\n}\n.content_sm5 {\n  @include font($font-body, 14px, 400, 18px, \"normal\");\n}\np {\n  @include font($font-body, 20px, 400, 30px, \"normal\");\n}\na,\nh5,\nh6 {\n  font-family: $font-body;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
